import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Track user activity in a module.
 * Call on module entry, key actions (select client, filter, export, etc.)
 */
export const trackActivity = async (action, module, details = {}) => {
  try {
    await axios.post(`${API}/track-activity`, { action, module, details }, { withCredentials: true });
  } catch (e) {
    // Silent fail — tracking should never block UX
  }
};
